import { createFeatureSelector } from '@ngrx/store';

export interface NumpadStoreState {
    focus: boolean;
}

export const numpadInitialState: NumpadStoreState = {
    focus: false,
};

export const numpadFeatureKey = 'numpad';

export interface INumpadRootState {
    numpad: NumpadStoreState;
}

export const numpadStateSelector = createFeatureSelector<NumpadStoreState>(numpadFeatureKey);
